import { createFileRoute, Outlet } from '@tanstack/react-router';
import Codebooks from '../../components/Codebooks';
import { PERMISSION_RIDE_TAG } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings/ride-tag')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_RIDE_TAG, ['read'], '/unauthorized', context);
    return { ...context };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RideTagLayout,
});

function RideTagLayout() {
  return (
    <>
      <Codebooks />
      <Outlet />
    </>
  );
}
